import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useState } from "react";
import { toast } from "react-toastify";
import { Label } from "@progress/kendo-react-labels";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import SuccessModal from "components/common/Modal/success";
import * as api from "api/index";
import styles from "../Settings.module.scss";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { PageTabItemTitle } from "components/tabs/TabItem/PageTabItemTitle";

import AddEditProfile from "./AddEditProfile";
import { AccountsGrid, CaseMangementGrid, ReportsGrid } from "./SecurityGrids";
import { useNavigate } from "react-router";
import SubmitButton from "components/common/SubmitButton";
import { resetCurrentUser } from "services/currentUserService";

const SecurityProfiles = (props) => {
  const [openForm, setOpenForm] = React.useState(false);
  const navigate = useNavigate();
  const [tabs, setTabs] = React.useState([
    "Case Managements",
    "Accounts",
    "Reports",
  ]);

  const [profileData, setProfIlesData] = useState([]);
  const [profileInfo, setProfileInfo] = useState();
  const [selected, setSelected] = React.useState(0);
  const [profiles, setProfiles] = useState([]);
  const [caseProfiles, setCaseProfiles] = useState([]);
  const [accountProfiles, setAccountProfiles] = useState([]);
  const [reportProfiles, setReportProfiles] = useState([]);
  const [editItem, setEditItem] = React.useState({
    ProductID: 1,
  });
  const [isInActive, setIsInactive] = useState(false);
  const [type, setType] = useState("");
  const [modalvalue, setmodalvalue] = useState(false);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [isSubmittingAll, setIsSubmittingAll] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    setIsSubmittingForm(true);
    try {
      if (type === "add") {
        await api.addSecurityProfile(event);
        setmodalvalue(true);
      } else if (type === "edit") {
        await api.updateSecurityProfile(event, event.profileId);
        setmodalvalue(true);
        setprofileValue(event);
      } else if (type === "copy") {
        const data = {
          ...profileValue,
          profileName: event.profileName,
          profileId: undefined,
        };
        await api.addSecurityProfile(data);
        setmodalvalue(true);
      } else {
        return;
      }
      setOpenForm(false);
    } catch (error) {
    } finally {
      setIsSubmittingForm(false);
    }
  };

  const saveData = async () => {
    setIsSubmittingAll(true);
    let caseCount = 0;
    let reportCount = 0;
    let accountCount = 0;
    caseProfiles.map((item) => {
      if (item.allowAccess) {
        caseCount += item.value;
      }
    });
    accountProfiles.map((item) => {
      if (item.allowAccess) {
        accountCount += item.value;
      }
    });
    reportProfiles.map((item) => {
      if (item.allowAccess) {
        reportCount += item.value;
      }
    });
    try {
      let data = {
        profileId: profileValue.profileId,
        profileName: profileValue.profileName,
        caseAccessCode: caseCount,
        accountAccessCode: accountCount,
        reportAccessCode: reportCount,
      };
      await api.updateSpecificProfiles(data, profileInfo.profileId);
      try { await resetCurrentUser(); } catch (error) {}
      toast.success("Settings Updated");
      // await onChangeProfile({ value: profileValue })
    } catch (error) {
      setIsSubmittingAll(false);
    } finally {
      setIsSubmittingAll(false);
    }
  };

  const [profileValue, setprofileValue] = useState();
  const handleChange = (type, e) => {
    let temp = profiles;
    if (type === "case") {
      caseProfiles?.map((item) => {
        if (item.name === e.dataItem.name) {
          return (item.allowAccess = e.value);
        }
      });
      setCaseProfiles([...caseProfiles]);
    } else if (type === "report") {
      reportProfiles?.map((item) => {
        if (item?.name === e.dataItem.name) {
          return (item.allowAccess = e.value);
        }
      });
      setReportProfiles([...reportProfiles]);
    } else if (type === "account") {
      accountProfiles.map((item) => {
        if (item.name === e.dataItem.name) {
          return (item.allowAccess = e.value);
        }
      });
      setAccountProfiles([...accountProfiles]);
    }
  };

  const fetchGridsData = async () => {
    setLoading(true);
    try {
      const data = await api.getSecurityProfilesItems();
      setTimeout(() => {
        setCaseProfiles(data?.data?.data?.case);
        setAccountProfiles(data?.data?.data?.accounts);
        setReportProfiles(data?.data?.data?.reports);
        setLoading(false);
      }, 100);
    } catch (error) {
      setLoading(false);
    }
  };

  const dataFetcher = async (e) => {
    try {
      const data = await api.getSecurityProfiles();
      let dataToPass = data?.data?.data;
      setProfIlesData(dataToPass);
      // onChangeProfile(data?.data?.data[0])
    } catch (error) { }
  };

  React.useEffect(() => {
    dataFetcher();
    fetchGridsData();
  }, []);

  const updateProfiles = (e) => {
    let array = [];
    caseProfiles.map((item) => {
      if ((e.caseAccessCode & item.value) === item.value) {
        item.allowAccess = true;
      } else {
        item.allowAccess = false;
      }
      array.push(item);
    });
    setCaseProfiles([...array]);
    accountProfiles.map((item) => {
      if ((e.accountAccessCode & item.value) === item.value) {
        return (item.allowAccess = true);
      } else {
        return (item.allowAccess = false);
      }
    });
    setAccountProfiles([...accountProfiles]);
    reportProfiles.map((item) => {
      if ((e.reportAccessCode & item.value) === item.value) {
        return (item.allowAccess = true);
      } else {
        return (item.allowAccess = false);
      }
    });
    setReportProfiles([...reportProfiles]);
  };

  const onChangeProfile = async (e) => {
    try {
      if (e.value !== undefined && e.value !== null) {
        try {
          setprofileValue(e.value);
          const data = await api.getSpecificProfiles(e.value.profileId);
          updateProfiles(data?.data.data);
          setProfileInfo(data?.data.data);
        } catch (error) { }
      } else if (e.value === null) {
        setprofileValue({
          profileName: "",
          value: null,
        });
        updateProfiles({
          caseAccessCode: 0,
          accountAccessCode: 0,
          reportAccessCode: 0,
        });
      }
    } catch (error) { }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const title = () => {
    if (type === "add") {
      return "Add Profile";
    } else if (type === "edit") {
      return "Edit Profile";
    } else {
      return "Copy Profile";
    }
  };

  const handleSelect = (e) => {
    setSelected(e.selected);
  };

  const checkInactive = () => {
    if (profileValue?.active === false) {
      setIsInactive(true);
    } else {
      setIsInactive(false);
    }
  };

  React.useEffect(() => {
    checkInactive();
  }, [profileValue]);

  return (
    <div className="d-flex flex-column h-100 w-100">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-shrink-0 settings-container">
        <div className="d-flex align-items-center">
          <div className="d-flex flex-column">
            <Label className="label mb-2">Select Profile</Label>
            <ComboBox
              style={{
                width: "350px",
              }}
              data={profileData}
              textField={"profileName"}
              iconClassName="wa"
              value={profileValue}
              onChange={onChangeProfile}
              placeholder={"Search Team"}
            />
          </div>
          <div>
            <Label className="label ms-3 mt-4 pt-1 text-danger">
              {isInActive && "Inactive"}
            </Label>
          </div>
        </div>
        <div className="mt-4 d-flex flex-wrap gap-1 gap-xl-3 ">
          <Button
            className={`common-btn setting-btn`}
            disabled={
              profileValue === undefined ||
              (profileValue !== undefined && profileValue.value === null)
            }
            onClick={(e) => {
              setEditItem(profileValue);
              setType("edit");
              setOpenForm(true);
            }}
          >
            Edit Profile
          </Button>
          <Button
            className={`common-btn setting-btn`}
            disabled={
              profileValue === undefined ||
              (profileValue !== undefined && profileValue.value === null)
            }
            onClick={(e) => {
              setType("copy");
              setOpenForm(true);
            }}
          >
            Copy Profile
          </Button>
          <Button
            className={`common-btn setting-btn`}
            onClick={() => {
              setType("add");
              setOpenForm(true);
            }}
          >
            Add Profile
          </Button>
        </div>
      </div>

      <div className="flex-grow-1 settings-container" style={{ minHeight: 0 }}>
        <TabStrip
          selected={selected}
          onSelect={handleSelect}
          keepTabsMounted={true}
          className="pagetab companytab h-100"
        >
          {tabs.map((item, index) => {
            return (
              item && (
                <TabStripTab
                  title={
                    <PageTabItemTitle
                      content={item}
                      selected={selected}
                      title={item}
                      index={tabs.indexOf(item)}
                    />
                  }
                  key={index}
                >
                  <div className="d-flex flex-column h-100 pt-2">
                    {item === "Case Managements" && (
                      <CaseMangementGrid
                        value={profileValue}
                        data={caseProfiles}
                        onChange={handleChange}
                        loading={loading}
                      />
                    )}
                    {item === "Accounts" && (
                      <AccountsGrid
                        data={accountProfiles}
                        onChange={handleChange}
                        loading={loading}
                      />
                    )}
                    {item === "Reports" && (
                      <ReportsGrid
                        data={reportProfiles}
                        onChange={handleChange}
                        loading={loading}
                      />
                    )}
                  </div>

                </TabStripTab>
              )
            );
          })}
        </TabStrip>
      </div>

      <div className={`${styles["buttons-container"]} d-flex align-items-center justify-content-end gap-2 px-4 py-3`}>
        <Button
          className="common-btn bgBtnSecondary"
          onClick={() => navigate("/settings")}
        >
          Cancel
        </Button>
        <SubmitButton
          onClick={saveData}
          isLoading={isSubmittingAll}
          disabled={
            profileValue === undefined ||
            (profileValue !== undefined && profileValue.value === null)
          }
        >
          Save
        </SubmitButton>
      </div>

      {modalvalue && (
        <SuccessModal
          onClose={() => {
            dataFetcher();
            setmodalvalue(false);
          }}
          message={type === "edit" ? "Profile Updated" : "Profile Added"}
        />
      )}
      {openForm && (
        <Dialog onClose={handleCancelEdit} width={600} title={title()}>
          <AddEditProfile
            cancelEdit={handleCancelEdit}
            onSubmit={handleSubmit}
            item={editItem}
            type={type}
            isSubmitting={isSubmittingForm}
          />
        </Dialog>
      )}
    </div>
  );
};

export default SecurityProfiles;
